import { fmtDay, type PeriodInfo } from '@klukka/core';

/** ‹ › stepping through pay periods. The forward arrow stops at the current one. */
export function PeriodNav({ pinfo, offset, onOffset }: {
  pinfo: PeriodInfo;
  offset: number;
  onOffset: (n: number) => void;
}) {
  return (
    <div className="p-nav">
      <button onClick={() => onOffset(offset - 1)} aria-label="Previous period">‹</button>
      <b>{fmtDay(pinfo.start)}–{fmtDay(pinfo.end)} {pinfo.start.slice(0, 4)}</b>
      <button disabled={offset >= 0} onClick={() => onOffset(offset + 1)} aria-label="Next period">›</button>
    </div>
  );
}
